import { Loader2, Send } from "lucide-react";
import { formatDateTime } from "./ui";

export default function DemoRequestNotesSection({ notes, note, setNote, saving, error, onAddNote }) {
  return (
    <section data-testid="demo-private-notes">
      <h3 className="text-sm font-bold text-slate-950 dark:text-white">Private Platform Admin notes</h3>
      <div className="mt-3 space-y-3">
        {(notes || []).length === 0 ? (
          <p className="rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-500 dark:border-white/15 dark:bg-white/[0.03] dark:text-slate-400" data-testid="demo-notes-empty">
            No private notes yet.
          </p>
        ) : (
          notes.map((item) => (
            <div key={item.note_id} className="rounded-xl border border-slate-200 bg-white p-4 dark:border-white/10 dark:bg-white/[0.03]" data-testid={`demo-note-${item.note_id}`}>
              <p className="whitespace-pre-wrap text-sm text-slate-700 dark:text-slate-300">{item.body}</p>
              <p className="mt-2 text-xs text-slate-400 dark:text-slate-500">{item.created_by} · {formatDateTime(item.created_at)}</p>
            </div>
          ))
        )}
      </div>
      <textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        data-testid="demo-note-input"
        placeholder="Add a private note about follow-up, qualification, or scheduling…"
        className="mt-4 min-h-28 w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/10 dark:border-white/15 dark:bg-white/5 dark:text-white dark:placeholder:text-slate-500"
      />
      {error && <p className="mt-3 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-red-700 dark:bg-red-500/10 dark:text-red-400" data-testid="demo-detail-error">{error}</p>}
      <button
        type="button"
        onClick={onAddNote}
        disabled={saving || !note.trim()}
        data-testid="demo-add-note-btn"
        className="mt-3 inline-flex items-center gap-2 rounded-xl bg-[#0052FF] px-4 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-blue-700 disabled:opacity-50"
      >
        {saving ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
        Add note
      </button>
    </section>
  );
}
